import React from "react";
import { useAppSettings } from "../../hooks/useAppSettings.tsx";

import { IBranch } from "../../models/Branch";
import { readBranches } from "../../services/branch.service.ts";
import Layout from "../../components/Layout.tsx";
import Title from "../../components/Title.tsx";
import {
  Panel,
  PanelBody,
  PanelHeader,
} from "../../components/panel/panel.jsx";
import CuadroMando from "./CuadroMando.tsx";
import { DatePicker } from "antd";
import locale from "antd/es/date-picker/locale/es_ES";
import { getCurrentFortnight } from "../../interfaces/formik/IReporteRelojChecador.ts";
import { getCurrentFortnightDayjs } from "../../models/Payroll.ts";
const { RangePicker } = DatePicker;

const NominaPage = () => {
  useAppSettings();

  const [branchesData, setBranchesData] = React.useState<IBranch[]>([]);
  const [selectedBranch, setSelectedBranch] = React.useState<IBranch[]>([]);
  const [viewMode, setViewMode] = React.useState<string>("general");
  const [dates, setDates] = React.useState(getCurrentFortnightDayjs());
  const [debounceTimer, setDebounceTimer] =
    React.useState<NodeJS.Timeout | null>(null);

  const fetchBranches = async () => {
    try {
      const branchList = await readBranches();
      setBranchesData(branchList);
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  React.useEffect(() => {
    fetchBranches();
  }, []);

  const sortedBranches = React.useMemo(
    () => [...branchesData].sort((a, b) => a.name.localeCompare(b.name, "es")),
    [branchesData]
  );

  const handleDateChange = (newDates: any) => {
    if (newDates && newDates.length > 0 && newDates[0] && newDates[1]) {
      try {
        const requestedStart = newDates[0].format("DD-MM-YYYY");
        const requestedEnd = newDates[1].format("DD-MM-YYYY");

        console.log(`SOLICITADA: ${requestedStart} al ${requestedEnd}`);
      } catch {}

      if (debounceTimer) {
        clearTimeout(debounceTimer);
      }

      const timer = setTimeout(() => {
        setDates({
          start: newDates[0],
          end: newDates[1],
        });
      }, 500);

      setDebounceTimer(timer);
    }
  };

  React.useEffect(() => {
    return () => {
      if (debounceTimer) {
        clearTimeout(debounceTimer);
      }
    };
  }, [debounceTimer]);

  return (
    <Layout loading={false}>
      <Title
        baseTitle="Reportes"
        basePath="/sucursales"
        activeTitle="Nómina"
        title={"Reporte de nómina"}
      />

      <div className="card border-0 m-4 rounded">
        <Panel>
          <PanelBody>
            <div className="p-4">
              <div className="d-flex justify-content-center align-items-center mb-4">
                <div style={{ width: "100%", maxWidth: "500px" }}>
                  <RangePicker
                    format="DD [de] MMMM [de] YYYY"
                    placeholder={["Fecha de inicio", "Fecha de fin"]}
                    size="large"
                    allowClear={false}
                    defaultValue={[dates.start, dates.end]}
                    onChange={handleDateChange}
                    locale={locale}
                    style={{
                      width: "100%",
                      borderRadius: "16px",
                      border: "1px solid #e5e7eb",
                      padding: "0.75rem 1rem",
                      fontSize: "0.95rem",
                      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                      transition: "all 0.3s ease-in-out",
                    }}
                    className="custom-date-picker"
                  />
                </div>
              </div>

              <div
                className="d-flex justify-content-center align-items-center flex-wrap"
                style={{ gap: "0.75rem", padding: "1rem" }}
              >
                {sortedBranches.map((branch) => {
                  const isSelected = selectedBranch.some(
                    (selected) => selected.id === branch.id
                  );
                  return (
                    <button
                      key={branch.id}
                      className="border-0 text-sm font-medium transition-all duration-300 ease-in-out shadow-sm"
                      style={{
                        background: isSelected
                          ? "linear-gradient(135deg, #fbbf24 0%, #f97316 50%, #dc2626 100%)"
                          : "linear-gradient(135deg, #fef3c7 0%, #fed7aa 50%, #fee2e2 100%)",
                        color: isSelected ? "#ffffff" : "#374151",
                        borderRadius: "16px",
                        padding: "0.75rem 1.5rem",
                        minWidth: "140px",
                        transform: isSelected ? "scale(1.05)" : "scale(1)",
                        boxShadow: isSelected
                          ? "0 4px 12px rgba(251, 191, 36, 0.4), 0 2px 4px rgba(220, 38, 38, 0.2)"
                          : "0 2px 4px rgba(0, 0, 0, 0.1)",
                      }}
                      onMouseEnter={(e) => {
                        if (!isSelected) {
                          e.currentTarget.style.transform = "scale(1.02)";
                          e.currentTarget.style.boxShadow =
                            "0 4px 8px rgba(0, 0, 0, 0.15)";
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (!isSelected) {
                          e.currentTarget.style.transform = "scale(1)";
                          e.currentTarget.style.boxShadow =
                            "0 2px 4px rgba(0, 0, 0, 0.1)";
                        }
                      }}
                      onClick={() => {
                        if (
                          selectedBranch.some(
                            (selected) => selected.id === branch.id
                          )
                        ) {
                          setSelectedBranch((records) =>
                            records.filter(
                              (selected) => selected.id !== branch.id
                            )
                          );
                        } else {
                          setSelectedBranch((records) => [...records, branch]);
                        }
                      }}
                    >
                      {branch.name}
                    </button>
                  );
                })}
              </div>
            </div>
          </PanelBody>
        </Panel>
      </div>

      <div className="card border-0 m-4 rounded">
        <Panel>
          <PanelBody>
            <div className="p-4">
              <CuadroMando selectedBranch={selectedBranch} dates={dates} />
            </div>
          </PanelBody>
        </Panel>
      </div>
    </Layout>
  );
};

export default NominaPage;
